import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import Breadcrumbs from '../../components/Breadcrumbs';
import CardMain from '../../components/Cards/CardMain';

export default function Page404() {
  const customText = (
    <span className="fs-3">
      A página que você está tentando acessar não existe.
    </span>
  );
  return (
    <Container fluid className="px-lg-4 px-xl-5">
      <Breadcrumbs title="Não encontrada" />
      <section>
        <Row>
          <Col md={12} lg={12}>
            <CardMain
              className="mb-4"
              subtitle="Support card subtitle"
              img="/img/not-found.jpg"
              text={customText}
              imgStyle={{ maxHeight: '300px' }}
              button={{
                variant: 'primary',
                label: 'Voltar',
                link: '/',
                goBack: 2,
              }}
            />
          </Col>
        </Row>
      </section>
    </Container>
  );
}
